import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["agreementsDecision", "agreementsType"];
import { changeUserPasswordApiRequest, getAccountAndAgreementsApiRequest, getAccountApiAgreements, getAllReservationsApiRequest, saveAccountApiRequest, saveAgreementsApiRequest, updateAccountImageRequest } from '@guryou/api-client';
import { ActionStatus, buildActionType, executeApiCall, FailedNotification, NotificationType, SuccessNotification } from '../core';
import { ACCOUNT_AND_AGREEMENTS_GET, ACCOUNT_AVATAR_UPDATE, ACCOUNT_GET_AGREEMENTS, ACCOUNT_PASSWORD_UPDATE, ACCOUNT_UPDATE, NOTIFICATION, USER_ALL_ORDERS } from '../types';
const getAllReservations = () => dispatch => dispatch(executeApiCall(getAllReservationsApiRequest(), USER_ALL_ORDERS));
const getAccountAndAgreements = silent => dispatch => dispatch(executeApiCall(getAccountAndAgreementsApiRequest(), ACCOUNT_AND_AGREEMENTS_GET, silent));
const getCurrentUserAgreements = silent => async dispatch => dispatch(executeApiCall(getAccountApiAgreements(), ACCOUNT_GET_AGREEMENTS, silent, undefined, true));
const updateCurrentUserAccount = data => async dispatch => {
  dispatch({
    type: buildActionType(ACCOUNT_UPDATE, ActionStatus.START)
  });
  const {
      agreementsDecision,
      agreementsType
    } = data,
    basicUserData = _objectWithoutProperties(data, _excluded);
  const saveAccountApiResponse = await saveAccountApiRequest(basicUserData);
  const saveAgreementsApiResponse = await saveAgreementsApiRequest({
    agreementsDecision,
    agreementsType
  });
  if (saveAccountApiResponse.success && saveAgreementsApiResponse.success) {
    dispatch({
      type: buildActionType(ACCOUNT_UPDATE, ActionStatus.DONE),
      payload: saveAccountApiResponse.data
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: SuccessNotification["".concat(ActionStatus.UPDATE)],
        variant: NotificationType.Success
      }
    });
  } else {
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: FailedNotification["".concat(ActionStatus.UPDATE)],
        variant: NotificationType.Error
      }
    });
  }
};
const updateUserImage = data => async dispatch => {
  dispatch({
    type: buildActionType(ACCOUNT_AVATAR_UPDATE, ActionStatus.START)
  });
  const updateAccountImageResponse = data.usersImage ? await updateAccountImageRequest(data) : {
    success: false
  };
  if (updateAccountImageResponse.success) {
    dispatch({
      type: buildActionType(ACCOUNT_AVATAR_UPDATE, ActionStatus.DONE),
      payload: updateAccountImageResponse.data
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: SuccessNotification["".concat(ActionStatus.UPDATE)],
        variant: NotificationType.Success
      }
    });
  } else {
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: FailedNotification["".concat(ActionStatus.UPDATE)],
        variant: NotificationType.Error
      }
    });
  }
};
const updateCurrentUserPassword = data => dispatch => dispatch(executeApiCall(changeUserPasswordApiRequest(data), ACCOUNT_PASSWORD_UPDATE));
export { getAllReservations, updateCurrentUserAccount, getCurrentUserAgreements, updateCurrentUserPassword, updateUserImage, getAccountAndAgreements };